import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Form, DatePicker } from 'grab-ui';
import css from './date-ranger-picker.less';

const { RangePicker } = DatePicker;
const FormItem = Form.Item;
const cx = classnames.bind(css);

const DateRangePicker = ({
  form,
  id,
  fieldOptions,
  disabledDate,
  format,
  fieldClassName,
  allowClear,
  disabled,
  onCalendarChange,
  onChange,
}) => {
  const { getFieldDecorator } = form;
  return (
    <FormItem className={cx('formItem', fieldClassName)}>
      {getFieldDecorator(id, fieldOptions)(
        <RangePicker
          disabledDate={disabledDate}
          format={format}
          allowClear={allowClear}
          disabled={disabled}
          onCalendarChange={onCalendarChange}
          onChange={onChange}
        />,
      )}
    </FormItem>
  );
};

DateRangePicker.propTypes = {
  id: PropTypes.string.isRequired,
  form: PropTypes.shape({}).isRequired,
  fieldOptions: PropTypes.shape({}),
  disabledDate: PropTypes.func.isRequired,
  format: PropTypes.string.isRequired,
  fieldClassName: PropTypes.string,
  allowClear: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onCalendarChange: PropTypes.func,
  onChange: PropTypes.func,
};

DateRangePicker.defaultProps = {
  fieldClassName: '',
  fieldOptions: {},
  disabled: false,
  onCalendarChange: () => {},
  onChange: () => {},
};

export default DateRangePicker;
